import consultaEstoque from '@/views/parametros/parametros.vue'
import login from '@/plugins/login.js';

export default {
    id: 'parametros',
    path: '/parametros',
    name: 'Configuração',
    component: consultaEstoque,
    isHeader: false,
    hidden: false,
    icone: 'settings',
    meta: {
        auth: true,
        titulo: 'Configuração',
        descricao: 'Pagina para parametrizações',
        possuiNivel: login.validarNivel('Parametros')
    },
}